import React, { useEffect } from "react"

export default function RedirectToLogin ({ link }) {

    useEffect(() => {localStorage.setItem('mobile', 'true'); window.location.href = link;}, []);

    return <></>
}